import React from "react";
import { useTranslation } from "./useTranslation";
import "./LanguageSwitcher.scss";

const LanguageSwitcher: React.FC = () => {
  const { t, locale, setLocale, supportedLocales, localeLabels } =
    useTranslation();

  return (
    <div className="lang-switch" role="group" aria-label={t("common.language")}>
      {supportedLocales.map((code) => (
        <button
          key={code}
          type="button"
          className={`lang-switch__btn ${
            locale === code ? "lang-switch__btn--active" : ""
          }`}
          onClick={() => setLocale(code)}
          aria-pressed={locale === code}
        >
          {localeLabels[code]}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
